import { INamespaceActionCreator, IReducer } from '@omaze/redux';
import { AnyAction } from 'redux';

import { SNACKBAR_TYPE } from '../../../SNACKBAR_TYPE';
import { SNACKBAR_ACTION } from '../../Snackbar.actions';
import {
    createSnackbarActionCreatorFactory,
    createSnackbarReducerFactory,
} from '../../Snackbar.factories';
import { ISnackbarState } from '../../Snackbar.state';

export interface ISnackbarCreateMessage {
    message: string;
    type: SNACKBAR_TYPE;
}

export const createAddAction: INamespaceActionCreator = createSnackbarActionCreatorFactory(
    SNACKBAR_ACTION.ADD,
    (snackbarMessage: string, type: SNACKBAR_TYPE): ISnackbarCreateMessage => {
        return {
            message: snackbarMessage,
            type,
        };
    },
);

export const addSnackbarMessageReducer: IReducer<ISnackbarState> = createSnackbarReducerFactory(
    SNACKBAR_ACTION.ADD,
    (state: ISnackbarState, action: AnyAction): void => {
        state.AUTO_ID = state.AUTO_ID + 1;

        state.messages.push({
            id: state.AUTO_ID,
            message: action.payload.message,
            type: action.payload.type,
        });
    },
);
